export enum SubscriptionPlanNameTypes {
  Free = 'free',
  Pro = 'pro',
  Premium = 'premium'
}
